<div *ngIf="showInfo">
    <label [class.label-invalid]="!itemSelected.id" for="comboTipoTransporte">
        <span>Selecione o tipo de transporte</span>
    </label>
    <div class="input-group mb-3 ng-autocomplete">
        <ng-autocomplete 
            [data]="tiposTransporte"
            searchKeyword="name"
            [itemTemplate]="itemTemplate"
            [(ngModel)]="itemSelected"
            (selected)='selectEvent($event)'
            (inputCleared)='onInputCleared()'
            [notFoundTemplate]="notFoundTemplate"
            placeholder='Pesquisar...'>                                 
        </ng-autocomplete>
    </div>

    <div *ngIf="itemSelected.id==2 || itemSelected.id==3">
        <label for="comboCdDestino">
            <span [class.label-invalid]="!itemSelectedDestino.id">Informe o CD de destino (Nº Deposito)</span>
        </label>
        <div class="input-group mb-3 ng-autocomplete">
        <ng-autocomplete 
            [data]="cdsDestino"
            searchKeyword="name"
            [itemTemplate]="itemTemplate"
            [(ngModel)]="itemSelectedDestino"
            (inputChanged)='onChangeSearch($event)'
            [notFoundTemplate]="notFoundTemplate"
            placeholder='Pesquisar...'>                                 
        </ng-autocomplete>
    
        <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.name"></a>
        </ng-template>
        
        <ng-template #notFoundTemplate let-notFound>
            <span>Nenhum registro encontrado</span>
        </ng-template>
        </div>
    </div>

    <label [class.label-invalid]="!itemSelectedTransportadora.id" for="comboTransportadoras">
        <span>Informe o CNPJ da transportadora</span>
    </label>
    <div class="input-group mb-3 ng-autocomplete">
        <ng-autocomplete 
            [data]="transportadoras"
            searchKeyword="name"
            [itemTemplate]="itemTemplate"
            [(ngModel)]="itemSelectedTransportadora"
            (inputChanged)='onChangeSearchTransportadora($event)'
            [notFoundTemplate]="notFoundTemplate"
            placeholder='Pesquisar...'>                                 
        </ng-autocomplete>
    </div>

    <div *ngIf="labelInfo">
        <label [class.label-invalid]="!info">{{labelInfo}}</label>
        <div style="margin: 0px 0px 10px 0px;" class="d-flex align-items-center input-group has-validations">
            <input class="form-control" aria-describedby="basic-question" type="text" placeholder=" " [(ngModel)]="info" required/>

            <div class="input-group-append">
                <span class="input-group-text" id="basic-question">
                    <fa-icon class="float-end" [icon]="['fas', 'question']" size="lg"></fa-icon>
                </span>
            </div>
        </div>
    </div>

    <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.name"></a>
    </ng-template>
    
    <ng-template #notFoundTemplate let-notFound>
        <span>Nenhum registro encontrado</span>
    </ng-template>

    <div class="container">
        <div class="row">
          <div class="col" style="padding: 0 !important">
            <div class="pb col next-button">
                <button type="button" class="btn btn-primary" [disabled]="!validaCampos()" (click)="proximo()">
                    PROSSEGUIR &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'arrow-circle-right']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>
</div>

<div *ngIf="showPlacas">
    <label [class.label-invalid]="!placas[0].placa">Placa motor</label>
    <div class="mb-3 d-flex align-items-center input-group has-validations">
        <input class="form-control" aria-describedby="basic-motor" type="text" (blur)="onBlurMotor(placas[0])" placeholder=" " [(ngModel)]="placas[0].placa" aria-describedby="basic-addon2" required>

        <div class="input-group-append">
            <span class="input-group-text" id="basic-motor">
                <fa-icon class="float-end" [icon]="['fas', 'truck']" size="lg"></fa-icon>
            </span>
        </div>
    </div>

    <div *ngIf="placas[0].tipo=='CAVALO'">
        <label [class.label-invalid]="!placas[1].placa">Placa carreta</label>
        <div class="mb-3 d-flex align-items-center input-group has-validations">
            <input class="form-control" type="text" (blur)="onBlurCarreta(placas[1])" placeholder=" " [(ngModel)]="placas[1].placa" aria-describedby="basic-addon2" required>
            
            <div class="input-group-append" [hidden]="placas[2].validar">
            <span class="input-group-text" style="cursor: pointer;" (click)="placas[2].validar=true">
                <fa-icon class="float-end" [icon]="['fas', 'plus']" size="lg"></fa-icon>
            </span>
            </div>
            <div class="input-group-append" [hidden]="!placas[2].validar">
                <span class="input-group-text">
                <fa-icon class="float-end" [icon]="['fas', 'truck']" size="lg"></fa-icon>
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="placas[2].validar">
        <label [class.label-invalid]="!placas[2].placa">Placa carreta</label>
        <div class="mb-3 d-flex align-items-center input-group has-validations">
            <input class="form-control" type="text" (blur)="onBlurCarreta(placas[2])" placeholder=" " [(ngModel)]="placas[2].placa" aria-describedby="basic-addon2" required>
            
            <div class="input-group-append">
            <span class="input-group-text" style="cursor: pointer;" (click)="placas[2].validar=false">
                <fa-icon class="float-end" [icon]="['fas', 'minus']" size="lg"></fa-icon>
            </span>
            </div>
        </div>
    </div>

    <div class="container" [hidden]="validaPlacas()">
        <div class="row">
          <div class="col" style="padding: 0 !important">
            <div class="pb col next-button">
                <!--BOTÃO SEM EVENTO, APENAS PARA FORÇAR A PERDA DE FOCUS DOS CAMPOS DE PLACA-->
                <button type="button" class="btn btn-primary" [disabled]="!validaPlacas(false)">
                    VALIDAR &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'check']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>

    <div class="container" [hidden]="!validaPlacas()">
        <div class="row">
            <div class="col" style="padding: 0 !important">
                <div class="pb col next-button">
                    <button type="button" class="btn btn-primary" (click)="enviarSolicitacao()">
                            ENVIAR &nbsp;
                        <fa-icon class="float-end" [icon]="['fas', 'paper-plane']" size="lg"></fa-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container" [hidden]="!wait">
    <div class="row">
      <div class="col" style="padding: 0 !important">
        <div class="pb col next-button">
            <button type="button" class="btn btn-primary" (click)="prosseguir()">
                PROSSEGUIR &nbsp;
                <fa-icon class="float-end" [icon]="['fas', 'arrow-circle-right']" size="lg"></fa-icon>
            </button>
        </div>
      </div>
    </div>
</div>